// Illustrations SVG inline pour les EmptyStates. Pas de dépendance externe :
// palette alignée sur design system (bg-page, border-subtle, accent).

export function IllustrationEmptyList({ className }: { className?: string }) {
  return (
    <svg
      width="160"
      height="120"
      viewBox="0 0 160 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <rect x="20" y="22" width="120" height="84" rx="10" fill="#F6F8FA" />
      <rect x="20" y="22" width="120" height="84" rx="10" stroke="#E5E7EB" />
      <rect x="32" y="38" width="52" height="6" rx="3" fill="#E5E7EB" />
      <rect x="32" y="54" width="80" height="4" rx="2" fill="#E5E7EB" />
      <rect x="32" y="64" width="64" height="4" rx="2" fill="#E5E7EB" />
      <rect x="32" y="80" width="80" height="4" rx="2" fill="#E5E7EB" />
      <rect x="32" y="90" width="44" height="4" rx="2" fill="#E5E7EB" />
      <circle cx="124" cy="92" r="18" fill="#3E63DD" fillOpacity="0.1" />
      <path d="M124 86v12M118 92h12" stroke="#3E63DD" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IllustrationNoSearchResults({ className }: { className?: string }) {
  return (
    <svg
      width="160"
      height="120"
      viewBox="0 0 160 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <rect x="24" y="28" width="112" height="72" rx="10" fill="#F6F8FA" stroke="#E5E7EB" />
      <circle cx="76" cy="60" r="18" stroke="#3E63DD" strokeWidth="2.5" fill="white" />
      <path d="M89 73l10 10" stroke="#3E63DD" strokeWidth="2.5" strokeLinecap="round" />
      <path d="M70 60h12M76 54v12" stroke="#E5E7EB" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export function IllustrationComingSoon({ className }: { className?: string }) {
  return (
    <svg
      width="160"
      height="120"
      viewBox="0 0 160 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden
    >
      <circle cx="80" cy="62" r="42" fill="#F6F8FA" stroke="#E5E7EB" />
      <path
        d="M80 42v22l14 8"
        stroke="#3E63DD"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
